import { Table, Typography } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import { useAccessMatrix } from '@/entities/admin/api/hooks';
import type { AccessMatrixRow } from '@/entities/admin/model/adminSchema';
import s from './AccessMatrixCard.module.scss';

function matrixCellClass(v: string) {
  if (v === 'full') return s.root__cell_ok;
  if (v === 'view') return s.root__cell_view;
  return s.root__cell_none;
}

function renderAccessCell(v: string) {
  if (v === 'full') return <span className={matrixCellClass(v)}>✓</span>;
  if (v === 'view') return <span className={matrixCellClass(v)}>👁</span>;
  return <span className={matrixCellClass(v)}>—</span>;
}

const { Text } = Typography;

export function AccessMatrixCard() {
  const { data: matrix } = useAccessMatrix();

  const matrixColumns: ColumnsType<AccessMatrixRow> = [
    { title: 'Модуль', dataIndex: 'module', key: 'module' },
    {
      title: 'Адм.',
      dataIndex: 'admin',
      key: 'admin',
      align: 'center',
      render: renderAccessCell,
    },
    {
      title: 'Спец.ОТ',
      dataIndex: 'ot_specialist',
      key: 'ot_specialist',
      align: 'center',
      render: renderAccessCell,
    },
    {
      title: 'Рук.',
      dataIndex: 'department_head',
      key: 'department_head',
      align: 'center',
      render: renderAccessCell,
    },
    {
      title: 'Мастер',
      dataIndex: 'master',
      key: 'master',
      align: 'center',
      render: renderAccessCell,
    },
    {
      title: 'Просм.',
      dataIndex: 'viewer',
      key: 'viewer',
      align: 'center',
      render: renderAccessCell,
    },
    {
      title: 'Сотр.',
      dataIndex: 'employee',
      key: 'employee',
      align: 'center',
      render: renderAccessCell,
    },
  ];

  return (
    <div className={s['root__section']}>
      <div className={s['root__table-title']}>Матрица прав доступа</div>
      <Table dataSource={matrix} columns={matrixColumns} rowKey="module" size="small" pagination={false} />
      <Text type="secondary" className={s['root__legend']}>
        ✓ — полный доступ · 👁 — только просмотр · — — нет доступа
      </Text>
    </div>
  );
}
